export default "__VITE_ASSET__0527504f__"